/**
 * Newsletter signup. Currently simulates a double opt-in request locally;
 * swap the body for a real call to the Cloud Function once one exists
 * (endpoint would enqueue a SendGrid confirmation email and write the
 * pending subscriber to Firestore). Keeping this as a single function means
 * that swap touches one file, not every call site.
 */
export async function subscribeToNewsletter(email: string): Promise<{ ok: true }> {
  if (import.meta.env.DEV) {
    console.info("[newsletter] would POST to signup Cloud Function:", email);
  }
  // TODO(backend): POST to the real signup Cloud Function, e.g.
  // await fetch("/api/newsletter/subscribe", { method: "POST", body: JSON.stringify({ email }) });
  await new Promise((resolve) => setTimeout(resolve, 500));
  return { ok: true };
}
